module.exports = __webpack_public_path__ + "static/media/人脸识别_lg.9b8fb920.jpg";